module.exports = __webpack_public_path__ + "static/media/security.0d4fff68.svg";